import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-team-line',
      title: 'Leadership Team Facilitation',
      description: 'Guide your senior leadership team through strategic planning, decision-making, and organizational alignment. I facilitate conversations that help leaders clarify priorities, strengthen collaboration, and move complex work forward.',
      link: '/leadership-facilitation'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Executive Coaching',
      description: 'One-on-one coaching for nonprofit executives and senior leaders navigating complexity, growth, and change. Together we strengthen leadership effectiveness, clarify priorities, and build the confidence needed to lead with impact.',
      link: '/executive-coaching'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Organizational Strategy',
      description: 'Strategic planning and organizational design support to help mission-driven organizations align strategy, people, and operations. From vision and theory of change to implementation planning, we build clear pathways to impact.',
      link: '/organizational-strategy'
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 gap-8">
          <div>
            <span className="text-[#2d9b9b] text-sm font-semibold tracking-wide uppercase">What I Offer</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1a2b4a] mt-4 leading-tight" style={{ fontFamily: 'Crimson Text, serif' }}>
              How I Support Leaders and Organizations
            </h2>
          </div>

          <p className="text-lg text-[#1a2b4a]/70 max-w-md leading-relaxed">
            I partner with nonprofit and social impact leaders navigating complex organizational challenges, providing strategic guidance, leadership development, and organizational design support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-12 shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-[#2d9b9b]`}></i>
              </div>

              <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4">
                {service.title}
              </h3>

              <p className="text-base text-gray-600 leading-relaxed mb-8">
                {service.description}
              </p>

              <Link 
                to={service.link}
                className="inline-flex items-center gap-2 text-[#2d9b9b] text-sm font-semibold hover:gap-3 transition-all duration-300 group-hover:underline whitespace-nowrap cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}